import { Dispatch } from 'react-redux';

import { StoreState } from '../../../reducers';
import { Action } from '../../../actions';
import { ConfigsData } from '../reducer';
import { TextFieldsEditableData } from '../utils/editableTextFields/textFieldsEditableData';
import { SlideData } from '../utils/indesignEditor/editableSliders/getData';
import { getClientAndResourceIds } from '../utils/helpers';
import { createNotification } from '../../NotificationBar/actions';
import Utils from '../../../utils';
import ApiUtils from '../../../utils/api';
import { Api } from '../../../typings/api';

export enum ConfigsActionKeys {
	SET_CONFIGS_DATA = '@@editor/configs/SET_CONFIGS_DATA',
	SET_EDITABLE_TEXT_FIELDS_DATA = '@@editor/configs/SET_EDITABLE_TEXT_FIELDS_DATA',
	UPDATE_EDITABLE_SLIDER_CONFIG = '@@editor/configs/UPDATE_EDITABLE_SLIDER_CONFIG',
	UPDATE_EDITABLE_ENRICHMENT_CONFIG = '@@editor/configs/UPDATE_EDITABLE_ENRICHMENT_CONFIG',
}

interface SetConfigsDataAction extends Action {
	type: ConfigsActionKeys.SET_CONFIGS_DATA;
	data: ConfigsData;
}

interface SetEditableTextFieldsDataAction extends Action {
	type: ConfigsActionKeys.SET_EDITABLE_TEXT_FIELDS_DATA;
	page: number;
	data: TextFieldsEditableData;
}

interface UpdateEditableSliderConfigAction extends Action {
	type: ConfigsActionKeys.UPDATE_EDITABLE_SLIDER_CONFIG;
	page: number;
	id: string;
	data: SlideData[];
}

interface UpdateEditableEnrichmentConfigAction extends Action {
	type: ConfigsActionKeys.UPDATE_EDITABLE_ENRICHMENT_CONFIG;
	page: number;
	token: string;
	resource: Api.AspDriveResourceItemLight;
}

export type ConfigsAction =
	SetConfigsDataAction |
	SetEditableTextFieldsDataAction |
	UpdateEditableSliderConfigAction |
	UpdateEditableEnrichmentConfigAction;

export const setConfigsData = (data: ConfigsData): SetConfigsDataAction => ({
	type: ConfigsActionKeys.SET_CONFIGS_DATA,
	data,
});

export const setEditableTextFieldsData = (page: number, data: TextFieldsEditableData): SetEditableTextFieldsDataAction => ({
	type: ConfigsActionKeys.SET_EDITABLE_TEXT_FIELDS_DATA,
	page,
	data,
});

export const updateEditableSliderConfig = (
	page: number,
	id: string,
	data: SlideData[],
	shouldSave: boolean = true,
) => (dispatch: Dispatch<StoreState>) => {
	const action: UpdateEditableSliderConfigAction = {
		type: ConfigsActionKeys.UPDATE_EDITABLE_SLIDER_CONFIG,
		page,
		id,
		data,
	};
	dispatch(action);

	if (shouldSave) {
		dispatch(saveConfigs());
	}
};

// the reader builds an enrichment from configs.json, so a replaced resource belongs there
export const updateEditableEnrichmentConfig = (
	page: number,
	token: string,
	resource: Api.AspDriveResourceItemLight,
) => (dispatch: Dispatch<StoreState>) => {
	const action: UpdateEditableEnrichmentConfigAction = {
		type: ConfigsActionKeys.UPDATE_EDITABLE_ENRICHMENT_CONFIG,
		page,
		token,
		resource,
	};
	dispatch(action);
};

export const saveConfigs = () => async (dispatch: Dispatch<StoreState>, getState: () => StoreState): Promise<void> => {
	try {
		const requestId = 'save-configs';
		Utils.cancelRequest(requestId);

		const { clientId, tempGId: resourceId } = getClientAndResourceIds();
		const { editor: { configs } } = getState();

		await ApiUtils.saveIndesignEditorConfigs(clientId, resourceId, JSON.stringify(configs), requestId);
	} catch (error) {
		// status is 0 for cancelled request, no need to display a notification
		if (error.status !== 0) {
			dispatch(createNotification('error.save_editor_data_error'));
		}
	}
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/actions/configs.ts